// Prevents Radix from auto-focusing the first focusable element (e.g. an input)
// when an overlay opens, but still moves focus into the overlay container.
// Leaving focus on the trigger button would trigger the browser warning
// "Blocked aria-hidden on an element because its descendant retained focus".
const onOverlayOpenAutoFocus = (event: Event) => {
  event.preventDefault();
  (event.target as HTMLElement | null)?.focus();
};

export { onOverlayOpenAutoFocus };
